import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import HTag from 'components/common/HTag'
import Modal from 'components/common/Modal'
import CareersForm from './CareersForm'
import * as css from './InternshipSteps.module.css'

const InternshipSteps = ({ heading, steps, label }) => {
  const { allSanityCareerCategory } = useStaticQuery(query)
  const categories = allSanityCareerCategory.nodes

  const [$open, set$open] = React.useState(false)

  return (
    <section id="apply" className="max-w-screen-xl mx-auto py-16 px-4">
      <HTag className="h0 text-center" {...heading} />

      <ol className="grid md:grid-cols-3 gap-8 my-12">
        {steps?.map((step, key) => (
          <li className={css.step} key={key}>
            <div>
              <h3 className="technical h4 mb-2">{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </li>
        ))}
      </ol>

      <p className="text-center">
        <button className="action lg" onClick={() => set$open(true)}>
          {label}
          <span className="arrow">➞</span>
        </button>
      </p>

      {$open && (
        <Modal className="max-w-screen-md mx-auto bg-white p-8" onClose={() => set$open(false)}>
          <CareersForm roles={categories} />
        </Modal>
      )}
    </section>
  )
}

export default InternshipSteps

const query = graphql`query InternshipSteps {
  allSanityCareerCategory(sort: {fields: orderRank}) {
    nodes {
      name
    }
  }
}`
